import { render } from "./PhoneNumberForm.vue?vue&type=template&id=1167978a&scoped=true"
import script from "./PhoneNumberForm.vue?vue&type=script&lang=js"
export * from "./PhoneNumberForm.vue?vue&type=script&lang=js"

import "./PhoneNumberForm.vue?vue&type=style&index=0&id=1167978a&scoped=true&lang=css"

import exportComponent from "C:\\Users\\javon\\mgs\\RabbitsfootOperatorApps\\playerpanel\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1167978a"]])

export default __exports__